export const _dataRoulette = {
    count_competition: 2,
    completed: "10 курсов и 15 задач",
    subscriptions: {
        period: '1 год',
        end: '27.09.2021'
    },
}
